export const tickerItems = [
  '演出市场年度数据发布：音乐节场次同比增长，票务系统承载压力同步上升',
  '竖屏短剧单月上新创下新高，都市与悬疑题材占比继续扩大',
  '直播平台更新合约模板，分成与保底条款同步微调',
  '多家待播剧调整排期，平台公布新一轮定档计划',
  '行业论坛聚焦内容合规，发布从业流程指引草案',
  '转会窗口进入最后一周，多支队伍集中官宣阵容补强',
];

export const newsItems = [
  {
    id: 'n-01',
    category: 'zongyi',
    tag: '综艺速报',
    title: '某户外综艺录制片段流出，嘉宾互动方式引发讨论',
    summary: '节目组暂未就片段来源作出说明，相关话题仍在持续发酵，后续赛制调整消息尚未确认。',
    time: '12分钟前',
    heat: '8.6万',
  },
  {
    id: 'n-02',
    category: 'yinyue',
    tag: '音乐演出',
    title: '音乐节抢票系统再度拥堵，主办方发布补偿说明',
    summary: '退票与改签通道同步开放，主办方称现场安保与检票通道方案已升级，将分批放票。',
    time: '26分钟前',
    heat: '9.1万',
  },
  {
    id: 'n-03',
    category: 'yingshi',
    tag: '影视动态',
    title: '多部待播剧调整排期，平台公布新一轮定档计划',
    summary: '原定档期作品顺延，片方回应称主要与后期制作进度有关，宣传节奏同步后移。',
    time: '43分钟前',
    heat: '6.2万',
  },
  {
    id: 'n-04',
    category: 'zhibo',
    tag: '直播生态',
    title: '直播平台更新主播合约模板，分成比例小幅调整',
    summary: '新模板自下月起执行，存量合约按原条款续约，平台强调不涉及强制改签。',
    time: '1小时前',
    heat: '5.4万',
  },
  {
    id: 'n-05',
    category: 'wanghong',
    tag: '网红动向',
    title: '头部内容创作者宣布团队重组，业务线有所收缩',
    summary: '团队回应称聚焦核心内容生产，相关调整属常规优化，网传裁员比例不实。',
    time: '1小时前',
    heat: '7.3万',
  },
  {
    id: 'n-06',
    category: 'saishi',
    tag: '赛事转会',
    title: '转会窗口临近关闭，多支队伍完成阵容补强',
    summary: '官宣节奏集中在最后一周，多家俱乐部同时上调青训球员，替补深度明显改善。',
    time: '2小时前',
    heat: '6.9万',
  },
  {
    id: 'n-07',
    category: 'duanju',
    tag: '短剧赛道',
    title: '竖屏短剧单月上新数量创新高，题材分布更分散',
    summary: '行业统计显示都市与悬疑题材占比上升，单集时长与投放节奏趋于稳定。',
    time: '2小时前',
    heat: '4.8万',
  },
  {
    id: 'n-08',
    category: 'yule',
    tag: '娱乐现场',
    title: '演唱会门票实名制再升级，转赠渠道明显收窄',
    summary: '主办方强调一证一票，入场核验环节前置，同时开放官方退票与候补通道。',
    time: '3小时前',
    heat: '8.2万',
  },
  {
    id: 'n-09',
    category: 'shangwu',
    tag: '商务观察',
    title: '文娱公司半年报陆续披露，内容成本占比下降',
    summary: '多家公司提到降本增效，项目立项更趋谨慎，长周期内容投入比例相应减少。',
    time: '4小时前',
    heat: '3.7万',
  },
  {
    id: 'n-10',
    category: 'wenhua',
    tag: '产业政策',
    title: '行业论坛聚焦内容合规，发布从业流程指引草案',
    summary: '草案就信息发布流程、素材授权与署名规范提出更细化的操作要求。',
    time: '5小时前',
    heat: '2.9万',
  },
  {
    id: 'n-11',
    category: 'yingshi',
    tag: '影视动态',
    title: '影视基地开放日吸引多人参观，周边配套同步升级',
    summary: '基地公布暑期档接待安排与预约方式，多处场景将首次对公众开放。',
    time: '6小时前',
    heat: '3.1万',
  },
  {
    id: 'n-12',
    category: 'zongyi',
    tag: '综艺速报',
    title: '老牌综艺宣布回归，常驻阵容六人同步官宣',
    summary: '节目组称赛制全面调整，录制周期缩短，首播时间将于近期公布。',
    time: '7小时前',
    heat: '7.8万',
  },
];